import styles from './AboutImages.module.css';

import I01_1 from '../Asset/Images/AboutPage/01-1.png';
import I01_2 from '../Asset/Images/AboutPage/01-2.png';
import I02 from '../Asset/Images/AboutPage/02.png';
import I03 from '../Asset/Images/AboutPage/03.png';
import I04 from '../Asset/Images/AboutPage/04.png';
import I05_1 from '../Asset/Images/AboutPage/05-1.png';
import I05_2 from '../Asset/Images/AboutPage/05-2.png';
import I06_1 from '../Asset/Images/AboutPage/06-1.png';
import I06_2 from '../Asset/Images/AboutPage/06-2.png';
import I06_3 from '../Asset/Images/AboutPage/06-3.png';
import I07 from '../Asset/Images/AboutPage/07.png';
import I08 from '../Asset/Images/AboutPage/08.png';
import I09 from '../Asset/Images/AboutPage/09.png';
import I10 from '../Asset/Images/AboutPage/10.png';
import I11 from '../Asset/Images/AboutPage/11.png';
import I12 from '../Asset/Images/AboutPage/12.png';

const AboutImages = () => {
  return (
    <div className={styles.container}>
      <div className={styles.Div01}>
        <img src={I01_1} alt='' />
        <img src={I01_2} alt='' />
      </div>

      <div className={styles.Div05}>
        <img src={I05_1} alt='' />
        <img src={I05_2} alt='' />
      </div>

      <div className={styles.Div06}>
        <img src={I06_1} alt='' />
        <img src={I06_2} alt='' />
        <img src={I06_3} alt='' />
      </div>

      <img className={styles.I02} src={I02} alt='' />
      <img className={styles.I03} src={I03} alt='' />
      <img className={styles.I04} src={I04} alt='' />
      <img className={styles.I07} src={I07} alt='' />
      <img className={styles.I08} src={I08} alt='' />
      <img className={styles.I09} src={I09} alt='' />
      <img className={styles.I10} src={I10} alt='' />
      <img className={styles.I11} src={I11} alt='' />
      <img className={styles.I12} src={I12} alt='' />
    </div>
  );
};

export default AboutImages;